import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

export const initialCreateHito = async (hitosList, taskName = null, uid = null) => {
    const newIdHito = uuidv4()
    const orden = (hitosList?.length || 0) + 1
    const newIdTask = uuidv4()

    const hitosNotDeleted = hitosList?.filter(it => !it.delete)
    const lastRowHito = hitosNotDeleted?.length - 1
    const lastRowTask = hitosNotDeleted[lastRowHito]?.tasks?.length - 1
    const lastDate = hitosNotDeleted[lastRowHito]?.tasks[lastRowTask]?.fecha_fin || null
    const newDateTask = lastDate ? moment(lastDate).add(1, 'days').format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')

    return {
        id: newIdHito,
        orden,
        nombre: 'Nueva etapa',
        open_text: false,
        type: 'hito',
        created: false,
        delete: false,
        hora_estimada: 0,
        hora_real: 0,
        costo_estimado: 0,
        costo_real: 0,
        porcentaje_avance: 0,
        tasks: [
            {
                id: newIdTask,
                id_hito: newIdHito,
                orden: 1,
                nombre: 'Nueva tarea',
                responsable: '',
                id_responsable: uid || 0,
                id_responsable_seguimiento: uid || 0,
                prioridad: 'alta',
                fecha_inicio: newDateTask,
                fecha_fin: newDateTask,
                porcentaje_avance: 0,
                hora_estimada: 0,
                hora_real: 0,
                costo_estimado: 0,
                costo_real: 0,
                estado: 'por hacer',
                type: 'task',
                created: false,
                delete: false
            }
        ]
    }

}

export const initialCreateTask = async (infoHito = null, taskName = null, uid = null) => {
    const newId = uuidv4()
    const length = infoHito.tasks.length
    const orden = length + 1
    const lastDate = infoHito?.tasks[length - 1]?.fecha_fin || null
    const newDateTask = lastDate ? moment(lastDate).add(1, 'days').format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')

    return {
        id: newId,
        id_hito: infoHito.id,
        orden,
        nombre: 'Nueva tarea',
        responsable: '',
        id_responsable: uid || 0,
        id_responsable_seguimiento: uid || 0,
        prioridad: 'alta',
        fecha_inicio: newDateTask,
        fecha_fin: newDateTask,
        porcentaje_avance: 0,
        hora_estimada: 0,
        hora_real: 0,
        costo_estimado: 0,
        costo_real: 0,
        estado: 'por hacer',
        created: false,
        type: 'task'
    }

}

export const getNumberDays = (dias) => {
    // console.log({ dias })
    return (dias > 0 ? (dias - 1) : 0)
}